import { NextSeo } from 'next-seo';
import React from 'react';
import firebase from '../../firebase';

// config
import config from '../../config';

// components
import RaffleInfo from '../../components/RaffleInfo';
import RaffleList from '../../components/RaffleList';
import PageHeader from '../../components/PageHeader';

export async function getServerSideProps() {
  const snapshot = await firebase
    .firestore()
    .collection('raffles')
    .where('endDate', '>', new Date(Date.now() - 3 * 24 * 60 * 60 * 1000))
    .get();
  const raffles = snapshot.docs.map((doc) => ({
    ...doc.data(),
    startDate: doc.data().startDate.toDate().toString(),
    endDate: doc.data().endDate.toDate().toString(),
  }));

  return {
    props: {
      raffles,
    },
  };
}

function RafflesPage({ raffles }) {
  const description = ``;

  return (
    <>
      <NextSeo title={`Raffles - ${config.siteName}`} description={description} />

      <PageHeader heading={'Raffles'} description={`Spend ${process.env.NEXT_PUBLIC_TOKEN_ABBR} on raffle tickets to win prizes`} />

      <RaffleList raffles={raffles} />
      <RaffleInfo />
    </>
  );
}

export default RafflesPage;
